import script from "./NavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=caea6e38&scoped=true&lang=css"

import exportComponent from "/Users/torrencebrown/Desktop/Projects/profession/portfolio-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caea6e38"]])

export default __exports__